import { render, staticRenderFns } from "./Loaded.vue?vue&type=template&id=5cfc2276&scoped=true&"
import script from "./Loaded.vue?vue&type=script&lang=js&"
export * from "./Loaded.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cfc2276",
  null
  
)

export default component.exports